
export const root = {
    transitionDuration: '{transition.duration}',
    focusRing: {
        width: '{focus.ring.width}',
        style: '{focus.ring.style}',
        color: '{focus.ring.color}',
        offset: '{focus.ring.offset}',
        shadow: '{focus.ring.shadow}'
    }
};

export const value = {
    background: '{primary.color}'
};

export const range = {
    background: '{content.border.color}'
};

export const text = {
    color: '{text.muted.color}'
};

export default {
    root,
    value,
    range,
    text
};
